import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ModelStudentprofile} from '../../../model/model.studentprofile';
import {LocaleService} from '../../../shared/services/locale.service';

@Component({
    selector: 'app-modal-company-student-contact',
    templateUrl: './modal-company-student-contact.component.html',
    styleUrls: ['./modal-company-student-contact.component.scss'],
    standalone: false
})
export class ModalCompanyStudentContactComponent implements OnInit {

  public data:any = {};

  entity:ModelStudentprofile|any = {
    id: '',
    firstName: '',
    infix:'',
    lastName: '',
    birthDate: '',
    phoneNumber: '',
    lookingFor: '',
    profileType: <any> '',
    avatarUri: '',
    profileStrength: 0,
    homeAddress: {
      street: '',
      number: '',
      numberSuffix: '',
      city: '',
      postalCode: '',
      country: '',
    },
    allowEmailNotifications: false,
    hasParentalConsent: true,
    isSubscribedToNewsletter: false,
    hasMediaConsent: false,
    hasAcceptedGdprPolicy: false,
    hasDataUsageConsent: false,
    parentEmailAddress: '',
    interests: [],
    areaOfInterests: <any> [],
    workExperiences: <any> [],
    educations: <any> [],
    languageProficiencies: <any> [],
    foreignExperiences: <any> [],
    studentProfileCvs: <any> []
  }

  /**
   * Constructor
   *
   * @param activeModal
   */
  constructor(public activeModal: NgbActiveModal, public locale: LocaleService) { }

  /**
   * Ng on init
   */
  ngOnInit(): void {

    if (this.data.hasOwnProperty('entity')) {
      this.entity = Object.assign({}, this.data.entity);
    }

  }

}
